// File category options (hierarchical)
export const FILE_CATEGORIES = [
  { group: 'Video', items: [
    { value: 'video_under_tack', label: 'Under Tack' },
    { value: 'video_walking', label: 'Walking' },
    { value: 'video_race_replay', label: 'Race Replay' },
    { value: 'video_other', label: 'Video - Other' },
  ]},
  { group: 'Photo', items: [
    { value: 'photo', label: 'Photo' },
  ]},
  { group: 'File (Doc)', items: [
    { value: 'doc_invoice', label: 'Invoice' },
    { value: 'doc_invoice_summary', label: 'Invoice Summary' },
    { value: 'doc_report', label: 'Report' },
    { value: 'doc_consignment_contract', label: 'Consignment Contract' },
    { value: 'doc_sale_company_contract', label: 'Sale Company Contract' },
    { value: 'doc_pedigree_proof', label: 'Pedigree Proof' },
    { value: 'doc_other', label: 'Doc - Other' },
  ]},
  { group: 'File (PDF)', items: [
    { value: 'pdf_invoice', label: 'Invoice' },
    { value: 'pdf_invoice_summary', label: 'Invoice Summary' },
    { value: 'pdf_invoice_package', label: 'Invoice Package' },
    { value: 'pdf_report', label: 'Report' },
    { value: 'pdf_mare_produce_record', label: 'Mare Produce Record' },
    { value: 'pdf_racing_form_ragozin', label: 'Racing Form - Ragozin' },
    { value: 'pdf_racing_form_beyer', label: 'Racing Form - Beyer' },
    { value: 'pdf_racing_form_thoroughmanager', label: 'Racing Form - Thoroughmanager' },
    { value: 'pdf_racing_form_lifetime_pp', label: 'Racing Form - Lifetime Past Performance' },
    { value: 'pdf_pedigree', label: 'Pedigree' },
    { value: 'pdf_consignment_contract', label: 'Consignment Contract' },
    { value: 'pdf_sale_company_contract', label: 'Sale Company Contract' },
    { value: 'pdf_sale_auth_keeneland', label: 'Sale Authorization - Keeneland' },
    { value: 'pdf_sale_auth_fasig', label: 'Sale Authorization - Fasig' },
    { value: 'pdf_sale_auth_obs', label: 'Sale Authorization - OBS' },
    { value: 'pdf_sale_auth_inglis', label: 'Sale Authorization - Inglis' },
    { value: 'pdf_sale_auth_other', label: 'Sale Authorization - Other' },
    { value: 'pdf_breeding_soundness_exam', label: 'Breeding Soundness Exam' },
    { value: 'pdf_catalogue_page', label: 'Catalogue Page' },
    { value: 'pdf_coggins', label: 'Coggins' },
    { value: 'pdf_eva', label: 'EVA' },
    { value: 'pdf_eye_certificate', label: 'Eye Certificate' },
    { value: 'pdf_fetal_sexing', label: 'Fetal Sexing' },
    { value: 'pdf_health_certificate', label: 'Health Certificate' },
    { value: 'pdf_jockey_club_papers', label: 'Jockey Club Papers' },
    { value: 'pdf_medication_disclosure', label: 'Medication & Treatment Disclosure' },
    { value: 'pdf_pedigree_proof', label: 'Pedigree Proof' },
    { value: 'pdf_scope', label: 'Scope' },
    { value: 'pdf_stallion_service_cert', label: 'Stallion Service Certificate' },
    { value: 'pdf_surgery_letter', label: 'Surgery Letter' },
    { value: 'pdf_vet_report', label: 'Vet Report' },
    { value: 'pdf_xrays', label: 'X-Rays' },
    { value: 'pdf_other', label: 'PDF - Other' },
  ]},
  { group: 'Questionnaire', items: [
    { value: 'questionnaire_cba_weanling', label: 'CBA - Weanling' },
    { value: 'questionnaire_cba_yearling', label: 'CBA - Yearling' },
    { value: 'questionnaire_cba_broodmare', label: 'CBA - Broodmare / Broodmare Prospect' },
    { value: 'questionnaire_cba_racing_prospect', label: 'CBA - Racing Prospect' },
  ]},
  { group: 'Other', items: [
    { value: 'other', label: 'Other' },
  ]},
];

// Helper to get category label from value
export const getCategoryLabel = (value) => {
  if (!value) return null;
  for (const group of FILE_CATEGORIES) {
    const item = group.items.find(i => i.value === value);
    if (item) return item.label;
  }
  return null;
};

// Helper to format file size
export const formatSize = (bytes) => {
  if (bytes === 0) return '0 B';
  const k = 1024;
  const sizes = ['B', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(1)) + ' ' + sizes[i];
};
